<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Leaders in Club Vicinities</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.community_leaders_number"
              label=" No of Community leaders*"
              required
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.leading_government_officers_number"
              label="No of leading government officers*"
              required
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.media_representatives_number"
              label=" Number of media representatives"
              required
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 01"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 02"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document3"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 03"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.community_leaders_number"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "LeadersInClubVicinities",

  components: { Alert, Snackbars },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      community_leaders_number: "",
      leading_government_officers_number: "",
      media_representatives_number: "",
      document1: null,
      document2: null,
      document3: null,
      members: [],
    },

    url: "leaders-in-club-vicinities",
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("document3", this.form.document3);
      fd.append(
        "media_representatives_number",
        this.form.media_representatives_number
      );
      fd.append(
        "leading_government_officers_number",
        this.form.leading_government_officers_number
      );
      fd.append("community_leaders_number", this.form.community_leaders_number);
      fd.append("month", this.$route.params.month);
      fd.append("key", "LEADER_LIST_CLUB_VICINITY");

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
